import { Pipe, PipeTransform } from '@angular/core';

/**
 * Toont een badge op basis van de status (good, moderate, bad).
 * Gebruik in template: {{ metric.status | appClimateBadge }}
 */
@Pipe({
  name: 'appClimateBadge',
})
export class ClimateBadgePipe implements PipeTransform {
  private readonly badges = {
    good: { label: 'Goed', class: 'badge bg-success text-success badge-soft' },
    moderate: { label: 'Matig', class: 'badge bg-warning text-warning badge-soft' },
    bad: { label: 'Slecht', class: 'badge bg-danger text-danger badge-soft' },
  };

  public transform(status: string | undefined | null): string {
    if (!status || !(status in this.badges)) return '';

    const badge = this.badges[status as keyof typeof this.badges];
    return `<span class="${badge.class}">${badge.label}</span>`;
  }
}
